<section class="product-page">
  <!-- <div class="d-flex update-available text-center align-items-center justify-content-center"
        [class.header-collapsed]="!isHeaderExpanded">
        <div>
            <span class="update">New update on Ezy|GST</span>
            <span class="px-2">This update will take about 20 minutes of complete downtime. CARATRED recommends checking
                with all departments to see if they have any ongoing tasks.</span>

        </div>
        <div class=" text-right">
            <button type="button" class="btn  update-now">Update Now</button>
        </div>
    </div> -->
  <div class="container-fluid">
    <div class="row px-3 py-2 pb-5 align-items-stretch">
      <div
        class="col-md-3 p-2"
        *ngFor="let card of subscribed_list; let i = index"
      >
        <div class="card h-100">
          <div class="card-body cursor-pointer" (click)="navigate_module(card)">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div>
                  <ng-container *ngIf="card.app_logo; else initialsBlock">
                    <img [src]="card.app_logo" class="fav-icon" alt="" />
                  </ng-container>

                  <ng-template #initialsBlock>
                    <div
                      class="initials-avatar"
                      [style.background-color]="
                        getAvatarColor(card?.display_name, 'subscribed')
                      "
                    >
                      {{ getInitials(card?.display_name) }}
                    </div>
                  </ng-template>
                </div>
                <div>
                  <p class="mb-0 mx-2 ezy-title">
                    {{ card?.display_name }}
                  </p>
                  <p class="mb-0">
                    <span
                      class="title-status mx-2 mb-0"
                      [ngbTooltip]="card?.description"
                      container="body"
                      placement="top"
                   *ngIf="card?.description" >
                      {{ card?.description || "" }}
                    </span>
                  </p>
                </div>
              </div>

              <!-- <div  class="cursor-pointer">
                                <i class="ri-share-box-line navigation-box f-14" (click)="navigate_module(card)"></i>
                            </div> -->
            </div>
          </div>
          <div class="card-footer px-3">
            <div class="d-flex justify-content-between align-items-center">
              <!-- (click)="openmodule(whyezyproducts,card.display_name,'subscribed_list')" -->
              <p
                class="view-guide mb-0"
                placement="top"
                style="cursor: not-allowed"
              >
                <i class="ri-information-line f-16" [id]="'sub-info-icon-' + i">
                </i>
                <span class="px-1">View Guide</span>
              </p>
              <div class="cursor-pointer">
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  (click)="navigate_module(card)"
                >
                  <strong>Open</strong>
                </button>
                <!-- <i class="ri-share-box-line navigation-box f-14" [id]="'share-icon-' + i" (click)="navigate_module(card)"></i> -->
              </div>
              <!-- <p class="videos mb-0 cursor-pointer" placement="top" ngbTooltip="Videos">
                                <i class="ri-video-on-fill f-14"></i>
                                Videos
                            </p> -->
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-3  p-2" *ngFor="let card of restrictedlist; let i = index" ></div> -->
      <div
        class="col-md-3 p-2"
        *ngFor="let card of restrictedlist; let i = index"
      >
        <div class="card h-100">
          <div class="card-body restricted" ngbTooltip="Restricted">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <!-- <div>
                  <img [src]="card.app_logo" class="fav-icon" alt="" />
                </div> -->
                <div>
                  <ng-container *ngIf="card.app_logo; else initialsBlock">
                    <img [src]="card.app_logo" class="fav-icon" alt="" />
                  </ng-container>

                  <ng-template #initialsBlock>
                    <div
                      class="initials-avatar"
                      [style.background-color]="
                        getAvatarColor(card?.display_name, 'restricted')
                      "
                    >
                      {{ getInitials(card?.display_name) }}
                    </div>
                  </ng-template>
                </div>
                <div>
                  <p class="mb-0 mx-2 ezy-title">
                    {{ card?.display_name }}
                  </p>
                  <p class="mb-0" *ngIf="card?.description">
                    <span class="title-status-locked mx-2 mb-0">
                      {{ card?.description || "" }}
                    </span>
                  </p>
                </div>
              </div>

              <!-- <div  >
                                <i class="ri-lock-2-line locked-key"></i>

                            </div> -->
            </div>
          </div>
          <div class="card-footer px-3 restricted">
            <div class="d-flex justify-content-between align-items-center">
              <p
                class="view-guide mb-0 cursor-pointer"
                placement="top"
                [style.pointer-events]="isDisabled ? 'none' : 'auto'"
              >
                <i
                  class="ri-information-line f-16"
                  [id]="'notsub-info-icon-' + i"
                  (click)="
                    openmodule(
                      whyezyproducts,
                      card.display_name,
                      'subscribed_list'
                    )
                  "
                >
                </i>
                <span
                  (click)="
                    openmodule(
                      whyezyproducts,
                      card.display_name,
                      'subscribed_list'
                    )
                  "
                  class="px-1"
                  >View Guide</span
                >
              </p>

              <!-- <p class="videos mb-0 cursor-pointer" placement="top" ngbTooltip="Videos">
                                <i class="ri-video-on-fill f-14"></i>
                                Videos
                            </p> -->
              <div class="h-30">
                <i
                  class="ri-lock-2-line locked-key"
                  [id]="'notsub-lock-icon-' + i"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-md-3 p-2"
        *ngFor="let card of notsubscribed_list; let i = index"
      >
        <div class="card h-100">
          <div
            class="card-body"
            style="background-color: #f6f6f6; cursor: not-allowed"
          >
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <!-- <div>
                  <img [src]="card.app_logo" class="fav-icon" alt="" />
                </div> -->
                <div>
                  <ng-container *ngIf="card.app_logo; else initialsBlock">
                    <img [src]="card.app_logo" class="fav-icon" alt="" />
                  </ng-container>

                  <ng-template #initialsBlock>
                    <div
                      class="initials-avatar"
                      [style.background-color]="
                        getAvatarColor(card?.display_name, 'notsubscribed')
                      "
                    >
                      {{ getInitials(card?.display_name) }}
                    </div>
                  </ng-template>
                </div>
                <div>
                  <p class="mb-0 mx-2 ezy-title">
                    {{ card?.display_name }}
                  </p>
                  <p class="mb-0" *ngIf="card?.description">
                    <span class="title-status-locked mx-2 mb-0 cursor-default">
                      {{ card?.description || "" }}
                    </span>
                  </p>
                </div>
              </div>

              <!-- <div>
                                <p class="view-guide mb-0 " placement="top" ngbTooltip="About">
                                    <i class="ri-information-line f-16 "
                                        (click)="openmodule(whyezyproducts,card.display_name,'subscribed_list')"> </i>
                                    <span (click)="openmodule(whyezyproducts,card.display_name,'subscribed_list')"
                                        class="px-1">View Guide</span>
                                </p>
                            </div> -->
            </div>
          </div>
          <div
            class="card-footer px-3 restricted"
            style="background-color: #f6f6f6"
          >
            <div class="d-flex justify-content-between align-items-center">
              <p
                class="view-guide mb-0 cursor-pointer"
                placement="top"
                [style.pointer-events]="isDisabled ? 'none' : 'auto'"
              >
                <i
                  class="ri-information-line f-16"
                  [id]="'notsub-info-icon-' + i"
                  (click)="
                    openmodule(
                      whyezyproducts,
                      card.display_name,
                      'subscribed_list'
                    )
                  "
                >
                </i>
                <span
                  (click)="
                    openmodule(
                      whyezyproducts,
                      card.display_name,
                      'subscribed_list'
                    )
                  "
                  class="px-1"
                  >View Guide</span
                >
              </p>

              <!-- <p class="videos mb-0 cursor-pointer" placement="top" ngbTooltip="Videos">
                                <i class="ri-video-on-fill f-14"></i>
                                Videos
                            </p> -->
              <div class="h-30">
                <a href="mailto:sales@caratred.com" target="_blank">
                  Subscribe
                </a>
                <!-- <span>Contact Sales</span> -->
                <!-- <a href="tel:+91 73 8629 5558">
                                    <i class="ri-phone-line me-2" [id]="'contact-phone-icon-' + i"></i>
                                </a>
                                <a href="mailto:sales@caratred.com">
                                    <i class="ri-mail-line" [id]="'contact-mail-icon-' + i"></i>
                                </a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer Tabs -->
  <!-- <div class="footer-tabs">
        <div class="footer-tab-item" [class.active]="activeTab === 'home'" (click)="activeTab = 'home'">
           
            <span>Home</span>
        </div>
        <div class="footer-tab-item" [class.active]="activeTab === 'workflows'" (click)="activeTab = 'workflows'">
          
            <span>Workflow Requests</span>
        </div>
        <div class="footer-tab-item" [class.active]="activeTab === 'masters'" (click)="activeTab = 'masters'">
       
            <span>Masters</span>
        </div>
        <div class="footer-tab-item" [class.active]="activeTab === 'settings'" (click)="activeTab = 'settings'">
          
            <span>Settings</span>
        </div>
    </div> -->

  <section class="notification-page d-none">
    <div class="d-flex">
      <!-- <div [ngStyle]="{ 'width': isNotificationOpen ? '88%' : '80%' }">
                <h4 class="subscribed-leverage mt-3 px-4">
                    {{custom_company}} is leveraging {{data_count}} products across operations
                </h4>
            </div> -->
      <!-- <div [ngStyle]="{ 'width': isNotificationOpen ? '12%' : '19.2%' }" class="bg-white notification-bar p-2">
                <div class="  d-flex  cursor-pointer" (click)="toggleNotification()">
                    <div>
                        <i [class]="isNotificationOpen ? 'ri-menu-fold-line' : 'ri-menu-unfold-line'"></i>
                        <small class="mx-2">Notification</small>
                    </div>

                </div>
            </div> -->
    </div>
    <div>
      <div class="container-fluid sub-products">
        <div class="row">
          <!-- LEFT SIDE -->
          <div
            class=""
            [ngClass]="{
              'col-md-9': subscribed_list?.length > 0,
              'col-12': !restrictedlist || restrictedlist.length === 0,
            }"
          >
            <div class="pb-5 subscribed-apps">
              <div *ngIf="subscribed_list?.length > 0">
                <h4 class="subscribed-title mt-3 mx-1">Subscribed</h4>
                <div #cardsContainer class="row pe-4">
                  <div
                    class="col-md-4 pe-0"
                    *ngFor="let card of subscribed_list; let i = index"
                  >
                    <!-- <div class="card  my-2 "
                                            [ngStyle]="{ 'background-color': cardColors[i % cardColors.length] }">
                                            <div class="card-body py-2 d-flex align-items-center">
                                                <i class="ri-draggable menu-bar cursor-pointer"></i>
                                                <div class="row">
                                                    <div class="col-md-9">
                                                        <div class="d-flex align-items-center">
                                                            <img [src]="card.app_logo" class="fav-icon" alt="">
                                                            <div class="line-height">
                                                                <p class="mb-0 mx-2 ezy-title"> {{ card?.display_name }}
                                                                </p>
                                                                <p class="title-status mx-2 mb-0"
                                                                    [ngbTooltip]="card?.description" container="body"
                                                                    placement="top">{{ card?.description || '' }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <div
                                                            class="d-flex align-items-center justify-content-end cursor-pointer">
                                                            <i class="ri-information-line info-bar mx-2" placement="top"
                                                                ngbTooltip="About"
                                                                (click)="openmodule(whyezyproducts,card.display_name,'subscribed_list')"></i>
                                                            <i class="ri-share-box-line navigation-box" placement="top"
                                                                ngbTooltip="Navigation"
                                                                (click)="navigate_module(card)"></i>
                                                        </div>
                                                    </div>
                                                </div>
                               
                                            </div>
                                        </div> -->

                    <div
                      class="card products-card"
                      [ngStyle]="{
                        'background-color': cardColors[i % cardColors.length],
                      }"
                    >
                      <div class="card-body py-2 d-flex align-items-center">
                        <i class="ri-draggable menu-bar cursor-pointer"></i>
                        <div class="row g-0 w-100 align-items-center">
                          <div class="col-md-9">
                            <div class="d-flex align-items-center">
                              <img
                                [src]="card.app_logo"
                                class="fav-icon"
                                alt=""
                              />
                              <div class="line-height">
                                <p class="mb-0 mx-2 ezy-title">
                                  {{ card?.display_name }}
                                </p>
                                <p
                                  class="title-status mx-2 mb-0"
                                  [ngbTooltip]="card?.description"
                                  container="body"
                                  placement="top"
                                >
                                  {{ card?.description || "" }}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div
                              class="d-flex align-items-center justify-content-end cursor-pointer"
                            >
                              <i
                                class="ri-information-line info-bar mx-2"
                                placement="top"
                                ngbTooltip="About"
                                (click)="
                                  openmodule(
                                    whyezyproducts,
                                    card.display_name,
                                    'subscribed_list'
                                  )
                                "
                              ></i>
                              <i
                                class="ri-share-box-line navigation-box"
                                placement="top"
                                ngbTooltip="Navigation"
                                (click)="navigate_module(card)"
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div *ngIf="restrictedlist?.length > 0">
                            <h4 class="subscribed-title mt-4 mb-3">Restricted for your role</h4>
                            <div class="d-flex gap-5">
                                <div *ngFor="let item of  restrictedlist">
                                    <div class="card my-2 bg-transparent">
                                        <div class="card-body">
                                            <i class="ri-prohibited-2-line restrict-icon"></i>
                                            <i class="ri-information-line info-icon cursor-pointer" placement="top"
                                                ngbTooltip="About"
                                                (click)="openmodule(whyezyproducts,item.display_name,'restrictedlist')"></i>

                                            <div class="text-center">
                                                <img [src]="item.app_logo" alt="" class="restricted-fav-icon mb-3">
                                                <h6 class="restricted-title m-0"> {{item?.display_name}}</h6>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="notsubscribed_list?.length > 0">
                            <h4 class="subscribed-title mt-4 mb-3">Not subscribed</h4>
                            <div class="d-flex gap-5">
                                <div *ngFor="let item of notsubscribed_list">
                                    <div class="card my-2 bg-pale-yellow">
                                        <div class="card-body">
                                            <i class="ri-lock-fill lock-icon"></i>
                                            <i class="ri-information-line info-icon cursor-pointer" placement="top"
                                                ngbTooltip="About"
                                                (click)="openmodule(whyezyproducts,item.display_name,'notsubscribed_list')"></i>
                                            <div class="text-center">
                                                <img [src]="item.app_logo" alt="" class="restricted-fav-icon mb-3">
                                                <h6 class="restricted-title m-0"> {{item?.display_name}}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
            </div>
            <!-- changing -->

            <!-- <div class="m-3">
                            <h4 class="subscribed-title mt-3 mx-1">Notifications</h4>
                            <div class="container-fluid    notification ">
                                <div class="row">

                                    <div class="col-md-4 py-3 border-right">
                                        <h6 class=" text-white fw-normal d-flex gap-3">
                                            <i class="ri-notification-badge-line"></i>
                                            What's new?
                                        </h6>
                                        <div class="bg-notification-card p-3 pb-1">
                                            <div class="modal-header justify-content-between">
                                                <p class="m-0 fs-13px">
                                                    <em>23 nov 2025</em>
                                                </p>
                                                <i class="ri-close-fill text-danger"></i>
                                            </div>
                                            <div class="modal-body pt-4">
                                                <div class="d-flex gap-3 align-items-center">
                                                    <img src="assets/images/ezyinvoicing.png" alt="" class="width-icon">
                                                    <h6 class="fw-semibold m-0"> Ezyinvoicing</h6>
                                                </div>
                                                <p class="fs-14px">Updating sales invoice dashboard globally for single
                                                    business
                                                    unit
                                                    companies.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 py-3 border-right">
                                        <h6 class=" text-white fw-normal d-flex gap-3">
                                            <i class="ri-mail-line"></i>
                                            Email
                                            notifications sent
                                        </h6>
                                        <div class="bg-notification-card p-3 pb-1 ">
                                            <div class="modal-header justify-content-between ">
                                                <p class="m-0 fs-13px">
                                                    <em>23 nov 2025</em>
                                                </p>
                                                <i class="ri-close-fill text-danger"></i>
                                            </div>
                                            <div class="modal-body pt-4">

                                                <p class="fs-14px"><span class="fw-semibold">Ezy|Forms</span> : Income
                                                    auditor
                                                    is
                                                    waiting for approval for
                                                    reverting goods to outside the hotel</p>
                                            </div>
                                        </div>
                                        <div class="bg-notification-card p-3 pb-1 mt-4">
                                            <div class="modal-header justify-content-between">
                                                <p class="m-0 fs-13px">
                                                    <em>23 nov 2025</em>
                                                </p>
                                                <i class="ri-close-fill text-danger"></i>
                                            </div>
                                            <div class="modal-body pt-4">

                                                <p class="fs-14px"><span class="fw-semibold">Ezy|Recon</span> : Front
                                                    Office
                                                    Manager is
                                                    waiting for
                                                    approval for 5 records in Bonvoy Wash Reconciliation</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 py-3">
                                        <h6 class=" text-white fw-normal d-flex gap-3">
                                            <i class="ri-checkbox-circle-line"></i>
                                            Pending
                                            tasks
                                        </h6>
                                        <div class="bg-notification-card p-3 pb-1">
                                            <div class="modal-header d-flex justify-content-between align-items-center">
                                                <h6 class="d-flex gap-3 m-0 align-items-center">
                                                    <img src="assets/images/ezygst.png" alt="">
                                                    <span class="fw-bold">GSTR1</span>
                                                </h6>
                                                <a class="link-primary fw-bold">View</a>
                                            </div>
                                            <div class="modal-body pt-4">
                                                <p class="fs-14px">We are encouraging GST to be delivered into services
                                                    so
                                                    that
                                                    we make
                                                    end to end
                                                    things precise and reduce costs and increase accuracy on you
                                                    reconciliations
                                                </p>
                                                <p class="m-0 fs-13px">
                                                    <em>23 nov 2025</em>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->

            <div
              *ngIf="notsubscribed_list?.length > 0"
              #moreSolutions
              id="moreSolutions"
            >
              <h4
                class="subscribed-title mx-1"
                [ngClass]="restrictedlist?.length > 0 ? 'mt-5' : 'mt-3'"
              >
                More solutions
              </h4>

              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div
                      class="col-md-2"
                      *ngFor="let card of notsubscribed_list"
                    >
                      <div class="my-2 position-relative">
                        <i class="ri-lock-fill more-solution"></i>

                        <div
                          class="product-restrict d-flex align-items-center justify-content-center min-height"
                        >
                          <div class="text-center">
                            <img [src]="card.app_logo" class="fav-icon pl-2" />
                            <p
                              class="mb-0 mx-2 ezy-title text-white ezy-display-name cursor-pointer"
                              ngbTooltip="{{ card.display_name }}"
                            >
                              {{ card.display_name }}
                            </p>
                            <i
                              class="ri-information-line info-bar mx-2 cursor-pointer information-icon"
                              ngbTooltip="About"
                              (click)="
                                openmodule(
                                  whyezyproducts,
                                  card.display_name,
                                  'notsubscribed_list'
                                )
                              "
                            ></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="col-md-3 unsub-products">
                    <div class="mx-3">
                        <div *ngIf="subscribed_list?.length > 0" >

                            <h4 class="subscribed-title mt-3 mx-1">
                                Restricted apps
                            </h4>

                                <div class="my-3 position-relative" *ngFor="let card of subscribed_list; let i = index" >

                                    <i class="ri-prohibited-line restrict-icon"></i>

                                    <div
                                        class="product-restrict d-flex align-items-center justify-content-between py-2">
                                        <div class="d-flex align-items-center gap-2 favicon-pl-1">
                                            <img [src]="card.app_logo" class="fav-icon" alt="" />
                                            <div class="line-height">
                                                <p class="mb-0 mx-2 ezy-title text-white">
                                                    {{ card?.display_name }}
                                                </p>
                                            </div>
                                        </div>

                                        <div class="d-flex align-items-center cursor-pointer">
                                            <i class="ri-information-line info-bar mx-2" placement="top"
                                                ngbTooltip="About"
                                                (click)="openmodule(whyezyproducts, card.display_name, 'subscribed_list')">
                                            </i>
                                        </div>
                                    </div>

                                </div>
                            
                        </div>

                        <div *ngIf="subscribed_list?.length > 0" >
                            <h4 class="subscribed-title mt-3 mx-1">More solutions</h4>
                            <div class="row" >
                                <div class="col-md-6" *ngFor="let card of subscribed_list; let i = index">
                                    <div class="my-2 position-relative">
                                        <i class="ri-lock-fill more-solution"></i>
                                        <div
                                            class="product-restrict d-flex align-items-center justify-content-between py-2 min-height">
                                            <div class="d-flex align-items-center gap-2">

                                                <div class="text-center">
                                                    <img [src]="card.app_logo" class="fav-icon pl-2" alt="">
                                                    <p class="mb-0 mx-2 ezy-title text-white ezy-display-name cursor-pointer"
                                                        ngbTooltip={{card?.display_name}}> {{ card?.display_name }}
                                                    </p>

                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center cursor-pointer">
                                                <i class="ri-information-line info-bar mx-2 information-icon"
                                                    placement="top"
                                                    (click)="openmodule(whyezyproducts,card.display_name,'subscribed_list')"
                                                    ngbTooltip="About"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                        </div>
                        
                        
                    </div>
                </div> -->

          <div
            class="col-md-3 unsub-products p-0"
            #scrollContainer
            (scroll)="onScroll()"
          >
            <div class="mx-3">
              <!-- Restricted Apps -->
              <div *ngIf="subscribed_list?.length > 0" #restrictedSection>
                <h4 class="subscribed-title mt-3 mx-1">Restricted apps</h4>
                <div
                  class="my-3 position-relative"
                  *ngFor="let card of subscribed_list; let i = index"
                >
                  <i class="ri-prohibited-line restrict-icon"></i>
                  <div
                    class="product-restrict d-flex align-items-center justify-content-between py-1"
                  >
                    <div class="d-flex align-items-center gap-2 favicon-pl-1">
                      <img [src]="card.app_logo" class="fav-icon" alt="" />
                      <p class="mb-0 mx-2 ezy-title text-white">
                        {{ card.display_name }}
                      </p>
                    </div>

                    <i
                      class="ri-information-line info-bar mx-2 cursor-pointer"
                      ngbTooltip="About"
                      (click)="
                        openmodule(
                          whyezyproducts,
                          card.display_name,
                          'restrictedlist'
                        )
                      "
                    ></i>
                  </div>
                </div>
              </div>
              <div
                id="moreSolutionsAnchor"
                style="position: relative; top: -180px"
              ></div>

              <!-- <div #moreSolutionsWrapper>
                                <div *ngIf="notsubscribed_list?.length > 0  " #moreSolutions id="moreSolutions">
                                    <h4 class="subscribed-title mx-1"
                                        [ngClass]="restrictedlist?.length > 0 ? 'mt-5' : 'mt-3'">More solutions</h4>

                                    <div class="row">
                                        <div class="col-md-6" *ngFor="let card of notsubscribed_list">
                                            <div class="my-2 position-relative">
                                                <i class="ri-lock-fill more-solution"></i>

                                                <div
                                                    class="product-restrict d-flex align-items-center justify-content-between py-2 min-height">
                                                    <div class="text-center">
                                                        <img [src]="card.app_logo" class="fav-icon pl-2" />
                                                        <p class="mb-0 mx-2 ezy-title text-white ezy-display-name cursor-pointer"
                                                            ngbTooltip="{{ card.display_name }}">
                                                            {{ card.display_name }}
                                                        </p>
                                                    </div>

                                                    <i class="ri-information-line info-bar mx-2 cursor-pointer information-icon"
                                                        ngbTooltip="About"
                                                        (click)="openmodule(whyezyproducts, card.display_name, 'notsubscribed_list')"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6" *ngFor="let card of notsubscribed_list">
                                            <div class="my-2 position-relative">
                                                <i class="ri-lock-fill more-solution"></i>

                                                <div
                                                    class="product-restrict d-flex align-items-center justify-content-between py-2 min-height">
                                                    <div class="text-center">
                                                        <img [src]="card.app_logo" class="fav-icon pl-2" />
                                                        <p class="mb-0 mx-2 ezy-title text-white ezy-display-name cursor-pointer"
                                                            ngbTooltip="{{ card.display_name }}">
                                                            {{ card.display_name }}
                                                        </p>
                                                    </div>

                                                    <i class="ri-information-line info-bar mx-2 cursor-pointer information-icon"
                                                        ngbTooltip="About"
                                                        (click)="openmodule(whyezyproducts, card.display_name, 'notsubscribed_list')"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6" *ngFor="let card of notsubscribed_list">
                                            <div class="my-2 position-relative">
                                                <i class="ri-lock-fill more-solution"></i>

                                                <div
                                                    class="product-restrict d-flex align-items-center justify-content-between py-2 min-height">
                                                    <div class="text-center">
                                                        <img [src]="card.app_logo" class="fav-icon pl-2" />
                                                        <p class="mb-0 mx-2 ezy-title text-white ezy-display-name cursor-pointer"
                                                            ngbTooltip="{{ card.display_name }}">
                                                            {{ card.display_name }}
                                                        </p>
                                                    </div>

                                                    <i class="ri-information-line info-bar mx-2 cursor-pointer information-icon"
                                                        ngbTooltip="About"
                                                        (click)="openmodule(whyezyproducts, card.display_name, 'notsubscribed_list')"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->

              <div #col3Bottom></div>
            </div>
            <!-- <button class="scroll-bottom-btn " *ngIf="showScrollBtn ">
                            <a href="#moreSolutionsAnchor" (click)="scrollToBottom()"
                                class="text-white text-decoration-none w-100 text-left">
                                {{ subscribed_list?.length }} More solutions
                                <i class="ri-arrow-down-line"></i>
                            </a>

                        </button> -->
          </div>
        </div>
      </div>
    </div>
  </section>
</section>
<!-- RIGHT SIDE -->
<!-- <div class="position-relative bg-white notification-scroll">

                    <h6 class="m-3 notification-title">
                        What’s new?
                    </h6>
                    <div class="card notification-card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between">
                                <p class="italic-text mb-0">
                                    <em>23 nov 2025</em>
                                </p>
                                <p class="mb-0">
                                    <i class="ri-close-line text-danger"></i>
                                </p>
                            </div>
                            <div class="d-flex">
                                <img src="/assets/images/favIcon 1 (2) 1.png" class="fav-icon">
                                <p class="mb-0 mx-2 notification-title">Ezyinvoicing</p>
                            </div>
                            <div class="notification-desc py-2">
                                Updating sales invoice dashboard globally for single business unit companies.
                                <a href="">View more</a>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <h6 class="m-3 notification-title">
                        <i class="ri-mail-line"></i> Email notifications sent
                    </h6>
                    <div class="card notification-card my-2">
                        <div class="card-body">
                            <div class="d-flex justify-content-between">
                                <p class="italic-text mb-0">
                                    <em>23 nov 2025</em>
                                </p>
                                <p class="mb-0">
                                    <i class="ri-close-line text-danger"></i>
                                </p>
                            </div>

                            <div class="notification-desc py-2">
                                <strong> Ezy|Forms</strong> : Income auditor is waiting for approval for reverting goods
                                to
                                outside the hotel
                            </div>
                        </div>
                    </div>
                    <div class="card notification-card my-2">
                        <div class="card-body">
                            <div class="d-flex justify-content-between">
                                <p class="italic-text mb-0">
                                    <em>23 nov 2025</em>
                                </p>
                                <p class="mb-0">
                                    <i class="ri-close-line text-danger"></i>
                                </p>
                            </div>

                            <div class="notification-desc py-2">
                                <strong>Ezy|Recon</strong> : Front Office Manager is waiting for approval for 5 records
                                in
                                Bonvoy Wash Reconciliation
                            </div>
                        </div>
                    </div>
                    <hr>
                    <h6 class="notification-title mx-3">
                        Pending tasks
                    </h6>
                    <div class="card transparent-border">
                        <div class="card-body">

                            <div class="d-flex">
                                <img src="/assets/images/favIcon 1 (2) 1.png" class="fav-icon">
                                <p class="mb-0 mx-2 notification-title">Ezyinvoicing</p>
                            </div>
                            <div class="notification-desc py-2">
                                Updating sales invoice dashboard globally for single business unit companies.
                                <a href="">View more</a>
                            </div>
                            <div class="d-flex justify-content-between">
                                <p class="italic-text mb-0">
                                    <em>23 nov 2025</em>
                                </p>

                            </div>
                        </div>
                    </div>
                </div> -->

<ng-template #whyezyproducts let-modal>
  <div style="border: 3px solid #0c9eba; border-radius: 8px">
    <div class="modal-header product-modal-header">
      <div>
        <p class="m-0 everyone">Hi everyone !</p>
        <h5 class="modal-title">What does {{ companyTitle }} do ?</h5>
        <div class="d-flex align-items-center">
          <i class="ri-play-circle-fill video-icon"></i>
          <p class="mb-0 mx-2 complete-demo">Complete Ezy|GST demo</p>
          <span class="mx-2">|</span>
          <div
            *ngIf="
              product_status === 'subscribed_list' ||
              product_status === 'restrictedlist'
            "
            class="d-flex align-items-center"
          >
            <p class="m-0">
              <i class="ri-share-box-line mx-2 video-icon"></i>
              <span class="complete-demo">/ezygst/home</span>
            </p>
            <span class="mx-2">|</span>
            <span class="bg-pink"
              ><i class="ri-vip-diamond-fill mx-2"></i>Subscription ends in 5
              days</span
            >
          </div>
          <div
            class="contact-sales"
            *ngIf="product_status === 'notsubscribed_list'"
          >
            <a href="mailto:sales@caratred.com" target="_blank">
              <i class="ri-mail-line mx-2"></i>
              <span class="contact-text">Contact sales</span>
            </a>
          </div>
        </div>
      </div>

      <button
        type="button"
        class="btn btn-primary"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      >
        <i class="ri-close-large-line"></i>
      </button>
    </div>

    <div class="modal-body my-scroll">
      <h6 class="statement">Problem Statement </h6>
      <p class="statement-para">
        Businesses struggle with complex GST processes, frequent data
        mismatches, compliance delays, and time-consuming manual documentation
        efforts.
      </p>
      <h6 class="statement">Solution </h6>
      <p class="statement-para">
        ezyGST is an intelligent platform designed to simplify GST data
        preparation, reconciliation, validation, and retention. It ensures
        accurate tax calculations, eliminates manual PMS errors, and focuses on
        delivering seamless GST compliance for the hospitality sector
      </p>
      <h6 class="statement">Benefits in GSTR 1</h6>
      <ul>
        <li class="statement-para">Detailed folio-level reconciliation</li>
        <li class="statement-para">Revenue vs tax reconciliation</li>
        <li class="statement-para">Automated unbilled revenue calculations</li>
        <li class="statement-para">
          Account books vs OPERA system reconciliation
        </li>
        <li class="statement-para">Advance payment reconciliation</li>
        <li class="statement-para">Comprehensive GSTR-1 reporting workbook</li>
      </ul>
      <h6 class="statement">Benefits in GSTR 2</h6>
      <ul>
        <li class="statement-para">Automated purchase register preparation</li>
        <li class="statement-para">Auto-fetch invoice data</li>
        <li class="statement-para">PR vs IMS reconciliation insights</li>
        <li class="statement-para">Auto-fetch of GSTR-2B portal</li>
        <li class="statement-para">PR vs 2B vendor tracker</li>
        <li class="statement-para">Multi-month ITC summary matching</li>
      </ul>
      <h6 class="statement">Process Flow</h6>
      <p class="statement-para">
        Automated GST calculations > Instant data validation > Streamline
        workflows
      </p>
    </div>
  </div>
</ng-template>
